export const INVOICES_SUMMARY_REQUEST_START: string = 'invoices/summary/REQUEST_START';
export const INVOICES_SUMMARY_REQUEST_FAIL: string = 'invoices/summary/REQUEST_FAIL';
export const INVOICES_SUMMARY_REQUEST_SUCCESS: string = 'invoices/summary/REQUEST_SUCCESS';
export const ANNUAL_STATEMENT_DOWNLOAD_REQUEST_START: string = 'annual_statement/download/REQUEST_START';
export const ANNUAL_STATEMENT_DOWNLOAD_REQUEST_FAIL: string = 'annual_statement/download/REQUEST_FAIL';
export const ANNUAL_STATEMENT_DOWNLOAD_REQUEST_SUCCESS: string = 'annual_statement/download/REQUEST_SUCCESS';
export const ANNUAL_STATEMENT_DOWNLOAD_REQUEST_RESET: string = 'annual_statement/download/REQUEST_RESET';
